import { Table, Button } from "react-bootstrap";
import { Edit, Trash } from "react-feather";
import { formatDate } from "../../App";

const GoldRateList = ({ goldRateData, onEdit, onDelete }) => {
  return (
    <Table striped bordered hover responsive className="align-middle text-center">
      <thead className="table-dark">
        <tr>
          <th>S.No</th>
          <th>Date</th>
          <th>22k Rate</th>
          <th>24k Rate</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {goldRateData.map((data, index) => (
          <tr key={data.id}>
            <td>{index + 1}</td>
            <td>{formatDate(data.date)}</td>
            <td>{data.r22kRate}</td>
            <td>{data.r24kRate}</td>
            <td>
              <Button variant="warning" size="sm" className="me-2" onClick={() => onEdit(data)}>
                <Edit size={16} />
              </Button>
              <Button variant="danger" size="sm" onClick={() => onDelete(data.id)}>
                <Trash size={16} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default GoldRateList;